module.exports = __webpack_public_path__ + "img/trophy.42c1eec2.png";